@if (productPage && productPage.numberOfElements > 0) {
  <div class="row">
    <div class="col-12">
      <div class="product-detail_related-products">
        <h1
          i18n="
            product detail: related products
            header@@product.detail.related-products.header"
          >
          Related products
        </h1>
        <div class="js-overview-grid">
          <div
            class="overview-grid overview-grid--cms hide-last-product-on-tablet"
            >
            @if (productPage) {
              @for (
                product of filterProductsOfPriceListLineNo(
                productPage.content
                )
                ; track
                product) {
                <product-item-grid
                  #productItemGridComponent
                  (lazyLoad)="productItemGridComponent.doLoad($event)"
                  (viewProductDetailClickEvent)="viewProductDetail($event)"
                  [loggedIn]="userService.isLoggedIn()"
                  [product]="product"
                  class="overview-product"
                  >
                </product-item-grid>
              }
            }
          </div>
          @if (productPage) {
            <div class="button-bar" style="text-align: center">
              <a
                (click)="getShowAllProductsUrl()"
                class="button button--secondary"
                i18n="@@product.detail.related-products.show.more"
                >
                Show more of this grower
              </a>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
